module.exports = __webpack_public_path__ + "img/57_3.05cfaf16.png";